$(document).ready(function () {
    $.Shop = $.Shop || {
        reloadPage: (showCart) => {
            const url = new URL(window.location);
            url.searchParams.set("showCart", showCart ? "1" : "0");
            window.location = url.href;
        },
        getCart: () =>
            axios
                .get("/shop/cart")
                .then((response) => response.data.cart)
                .catch((error) => console.error(error)),
        addItemToCart: (pn, quantityElement, eventId) => {
            const quantity = quantityElement
                ? parseInt($(quantityElement).val())
                : 1;
            axios
                .post("/shop/cart-add", { pn, quantity, eventId })
                .then(() => $.Shop.reloadPage(true))
                .catch((error) => console.error(error));
        },
        removeItemFromCart: (pn, eventId) =>
            axios
                .post("/shop/cart-remove", { pn, eventId })
                .then(() => $.Shop.reloadPage(true))
                .catch((error) => console.error(error)),
        refreshCart: () => {
            const showCart =
                new URL(window.location).searchParams.get("showCart") === "1";
            const el = $("#cart");
            const positionEl = $("#cart .card-body ul");
            if(el.length){
                el.hide();
                if (showCart) el.addClass("show");
            }
            if (positionEl.length && positionEl.children().length > 0) el.show();
        },
    };

    $("#cart .cart-toggle").on("click", function () {
        $("#cart").toggleClass("show");
    });

    $.Shop.refreshCart();
});
